/*
 * @Author: bbqin
 * @Date: 2021-07-20 10:24:41
 * @LastEditTime: 2021-12-20 09:54:09
 * @LastEditors: bbqin
 * @Description: 啥功能呢
 * @FilePath: \Platform_Front\src\platform\base\Calculator\modal.js
 * 这锅我不背
 */
import React, { Component } from "react";
import ReactDOM from "react-dom";
import Modal from '../Modal';
import Button from '../Button';
import HotKeys from '../HotKeys';
import Tooltip from '../Tooltip';
import Big from "big.js";
import Panel from './panel';

function noop() {
}

require('./index.less');

const defaultFontSize = {
    historyFormula: 12,
    historyResult: 16,
    inputResult: 22,
    inputFormula: 18,
    keyBtn: 14,
    historyTitle: 12,
    diameter: 30,
};

class ModalWrapper extends Component {
    constructor(props) {
        super(props);
        this.state = {
            size: '',
            oldSize: props.size,
            show: '',
            value: '',
            fontSize: defaultFontSize,
        };
    }

    render() {
        let { size, fontSize } = this.state;
        let {
            id = 'modal' + new Date().getTime(),
            beSureClick = noop,
            cancelClick = noop,
            onHide = noop,
            calculateHandle = noop,
            langJson,
            leftBtnName = langJson['0005'],
            rightBtnName = langJson['0006'],
            maxButtonClick,
            value,
            show,
            className,
            ...others
        } = this.props;

        return (
            <Modal
                fieldid={id}
                show={show}
                ref={Modal => (this.Modal = Modal)}
                id={id}
                className={className + ` ${size === 'max' ? 'nc-modal-max' : ''} `}
                size={size}
                zIndex={999}
                max={size === 'max'}
                centered={true}
                minHeight={390}
                minWidth={400}
                width={400}
                onHide={() => {
                    this.setState({ fontSize: defaultFontSize });
                    onHide && onHide();
                }}
                onResize={() => {
                    let fontSize = this.state.fontSize;
                    let modalDom = ReactDOM.findDOMNode(this.Modal)
                    // console.log(this.Modal);
                    let modalBody = modalDom && modalDom.querySelector('.u-modal-body');
                    let height = modalBody && modalBody.offsetHeight;
                    let width = modalBody && modalBody.offsetWidth;
                    if (height && width) {
                        let base = Big(400).times(390);
                        let current = Big(width).times(height);
                        console.log(base, current);
                        fontSize = {
                            historyFormula: Big(12).times((current).div(base).sqrt()).round(0),
                            historyResult: Big(16).times((current).div(base).sqrt()).round(0),
                            inputResult: Big(22).times((current).div(base).sqrt()).round(0),
                            inputFormula: Big(18).times((current).div(base).sqrt()).round(0),
                            keyBtn: Big(14).times((current).div(base).sqrt()).round(0),
                            historyTitle: Big(12).times((current).div(base).sqrt()).round(0),
                            diameter: Big(30).times(width > height ? Big(height).div(304) : Big(width).div(398)).round(0),
                        };
                        this.setState({ fontSize });
                    }
                }}
                {...others}
            >
                { <HotKeys
                    keyMap={{
                        sureBtnHandler:
                            HotKeys.USUAL_KEYS.MODAL_CONFIRM,
                        cancelBtnHandler:
                            HotKeys.USUAL_KEYS.MODAL_CALCEL,
                    }}
                    handlers={{
                        sureBtnHandler: () => {
                            // 确定按钮的事件 增加top的判断避免所有弹窗逻辑都被触发 by bbqin
                            if (this.Modal && this.Modal.isTopModal()) {
                                console.log(
                                    'createModal  sureBtnHandler 事件回调',
                                    this.Modal.isTopModal(),
                                );
                                calculateHandle && calculateHandle(this.state.value);
                                this.setState({ fontSize: defaultFontSize });
                                beSureClick && beSureClick();
                            }
                        },
                        cancelBtnHandler: () => {
                            // 取消按钮的事件 增加top的判断避免所有弹窗逻辑都被触发  by bbqin
                            if (this.Modal && this.Modal.isTopModal()) {
                                console.log(
                                    'createModal cancelBtnHandler 事件回调',
                                );
                                this.setState({ fontSize: defaultFontSize });

                                cancelClick && cancelClick();
                            }
                        },
                    }}
                    className="calculator-hotkeys-wrapper"
                    focused={true}
                    attach={document.body}
                    display="inline"
                />}
                <Modal.Header fieldid="header-area" closeButton showMaxButton={false} headerRight={false} maxButtonClick={(max, e) => {
                    let oldSize = this.state.oldSize;
                    this.setState({
                        oldSize: oldSize,
                        size: max ? 'max' : oldSize,
                    }, () => {
                        maxButtonClick && maxButtonClick(max, e);
                    })
                }}>
                    <Modal.Title fieldid='calculate-title'>{langJson['009']}</Modal.Title>
                </Modal.Header>
                <Modal.Body >
                    <Panel
                        fontSize={fontSize}
                        value={value}
                        calculateHandle={value => {
                            this.setState({ value });
                        }}
                    />
                </Modal.Body>
                {
                    <Modal.Footer>
                        {<Tooltip
                            placement="top"
                            inverse
                            overlay={`${leftBtnName}  (${HotKeys.USUAL_KEYS.MODAL_CONFIRM})`}
                            trigger={['hover', 'focus']}
                            className="model-helper-overlay"
                        >
                            <Button
                                onClick={() => {
                                    calculateHandle && calculateHandle(this.state.value);
                                    this.setState({ fontSize: defaultFontSize });
                                    beSureClick && beSureClick();
                                }}
                                colors="primary"
                                tabIndex="0"
                                fieldid="confirm"
                            >
                                {leftBtnName}(<span className="text-decoration-underline">Y</span>)
                            </Button>
                        </Tooltip>}

                        {<Tooltip
                            placement="top"
                            inverse
                            overlay={`${rightBtnName}  (${HotKeys.USUAL_KEYS.MODAL_CALCEL})`}
                            trigger={['focus', 'hover']}
                            className="model-helper-overlay"
                        >
                            <Button
                                onClick={() => {
                                    this.setState({ fontSize: defaultFontSize });

                                    cancelClick && cancelClick();
                                }}
                                shape="border"
                                tabIndex="0"
                                fieldid="cancel"
                            >
                                {rightBtnName}(<span className="text-decoration-underline">N</span>)
                            </Button>
                        </Tooltip>}
                    </Modal.Footer>
                }
            </Modal>
        );
    }
}

export default ModalWrapper;